import { client } from "./client";
import interceptors from "./interceptors";
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDetailSerialConvert(params) {
	return client.get("api/serial-convert/detail", {
		params: {
			serial_convert_code : params
		},
	});
}

function getSerialConvert(params) {
	return client.get("api/serial-convert/data", {
		params: params
	});
}

function getSerialConvertAll(params) {
	return client.get("api/serial-convert/all", {
		params: params
	});
}

function getSerialConvertRoam(params) {
	return client.get("api/serial-convert/roam", {
		params
	});
}

function approveSerialConvert(params) {
	return client.post("api/serial-convert/approve", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function scanSerial(params) {
	return client.post("api/sdo/scan", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

export default {
	getDetailSerialConvert,
	getSerialConvertRoam,
	getSerialConvert,
	getSerialConvertAll,
	approveSerialConvert,
	scanSerial
};